import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { SERVICES_CAROUSEL_IMAGES } from '../data/site';
import { BeardIcon, BrowIcon, CarIcon, ChildIcon, ColorIcon, CrownIcon, EarIcon, NoseIcon, ScissorsIcon, SeniorIcon, StarIcon } from './icons/Icons';
import { useLanguage } from '../data/i18n';
type Service = {
  name: string;
  nameEn: string;
  Icon: (props: {
    className?: string;
  }) => JSX.Element;
  featured?: boolean;
};
const services: Service[] = [{
  name: 'Corte de Pelo y Barba',
  nameEn: 'Haircut & Beard',
  Icon: BeardIcon
}, {
  name: 'Corte de Pelo',
  nameEn: 'Haircut',
  Icon: ScissorsIcon
}, {
  name: 'VIP Experiencia',
  nameEn: 'VIP Experience',
  Icon: CrownIcon
}, {
  name: 'Corte de Pelo Niño',
  nameEn: 'Boy Haircut',
  Icon: ChildIcon
}, {
  name: 'Visita a Domicilio VIP',
  nameEn: 'House Call VIP',
  Icon: CarIcon,
  featured: true
}, {
  name: 'Atención pensada para los jubilados',
  nameEn: 'Senior Care',
  Icon: SeniorIcon
}, {
  name: 'Marcación de cejas',
  nameEn: 'Eyebrow shaping with a razor',
  Icon: BrowIcon
}, {
  name: 'Cera caliente en orejas',
  nameEn: 'Hot wax in ears',
  Icon: EarIcon
}, {
  name: 'Cera caliente en nariz',
  nameEn: 'Hot wax on nose',
  Icon: NoseIcon
}, {
  name: 'Color de Pelo',
  nameEn: 'Hair Color',
  Icon: ColorIcon
}];
export function Services() {
  const {
    lang,
    t
  } = useLanguage();
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % SERVICES_CAROUSEL_IMAGES.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  return <section id="servicios" className="relative w-full bg-black py-24 sm:py-32" data-id="element-192" data-mp="3g4n7x63mdf92">
      <div className="mx-auto max-w-6xl px-6" data-id="element-193" data-mp="3kzj5elrmkutk">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1]
      }} className="mx-auto mb-16 max-w-2xl overflow-hidden ring-1 ring-white/15 relative aspect-[4/5] sm:aspect-[3/4] bg-black" data-id="element-194" data-mp="24mkt0eqzfk4x">
          <AnimatePresence mode="wait" data-id="element-195" data-mp="1grsk9k93g08x">
            <motion.img key={currentIndex} initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.8
          }} src={SERVICES_CAROUSEL_IMAGES[currentIndex]} alt="DuvayBarberVIP Team" className="absolute inset-0 h-full w-full object-contain grayscale contrast-125 transition-all duration-500 hover:grayscale-0" data-id="element-196" data-mp="1gqqzup66u1ej" />
          </AnimatePresence>
        </motion.div>

        <div className="text-center" data-id="element-197" data-mp="sveh4ij7x6n3">
          <p className="font-sans text-[10px] uppercase tracking-[0.4em] text-ash" data-id="element-198" data-mp="2s6xmkn5bbws0">{t.services.eyebrow}</p>
          <h2 className="mt-5 font-display text-5xl sm:text-7xl tracking-[0.05em] text-bone" data-id="element-199" data-mp="2n84bf1di0hv0">{t.services.title}</h2>
        </div>

        <ul className="mt-16 divide-y divide-white/10 border-y border-white/10" data-id="element-200" data-mp="2uqcaisctby3e">
          {services.map((service, i) => <motion.li key={service.name} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.07
        }} className={`group flex flex-col gap-3 py-8 sm:flex-row sm:items-center sm:gap-8 ${service.featured ? 'bg-white/[0.04] px-4 sm:px-6' : ''}`} data-id="element-201" data-mp="2zom5b1umkwoh" data-mpi={i}>
              <span className="flex h-12 w-12 shrink-0 items-center justify-center border border-white/25 text-bone transition-colors group-hover:border-white group-hover:bg-white group-hover:text-black" data-id="element-202" data-mp="2lpmebnjn45p5">
                <service.Icon className="w-6 h-6" data-id="element-203" data-mp="zondkun1imb" />
              </span>

              <div className="sm:flex-1" data-id="element-204" data-mp="51ik5i1pq2h7">
                <h3 className="flex items-center gap-2 font-display text-2xl sm:text-3xl tracking-[0.08em] text-bone" data-id="element-205" data-mp="508kiof7om8g">
                  {service.featured && <StarIcon className="w-4 h-4 text-[#D4AF37]" data-id="element-206" data-mp="3urfmy3vwozw3" />}
                  {lang === 'es' ? service.name : service.nameEn}
                </h3>
                <p className="mt-1 font-sans text-[10px] sm:text-[11px] uppercase tracking-[0.3em] text-white/50" data-id="element-207" data-mp="dkn9cy60m31k">
                  {lang === 'es' ? service.nameEn : service.name}
                </p>
              </div>

              <a href="#reserva" className="self-start sm:self-auto font-sans text-[10px] uppercase tracking-[0.3em] text-ash underline-offset-8 hover:text-white hover:underline transition-colors" data-id="element-208" data-mp="mhntutpyrgzq">
                {t.services.book}
              </a>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}